// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import loadingAnimationSource from './loading-animation.svg';

export function LoadingIndicator(): Node {
  return(
    <LoadingWrapper>
      <img src={loadingAnimationSource} alt="loading indicator"/>
    </LoadingWrapper>
  );
}

const LoadingWrapper = styled.div`
  & > img {
    height: 64px;
  }
  grid-column: 1 / 3;
  display: flex;
  justify-content: center;
`;
